import { format, differenceInDays, parseISO, isAfter, isBefore } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ProgressBarProps {
  startDate?: number;
  endDate?: number;
}

export default function ProgressBar({ startDate, endDate }: ProgressBarProps) {
  // Retorna null se não tiver datas ou se a data final já passou
  if (!startDate || !endDate || isAfter(new Date(), new Date(endDate))) {
    return null;
  }

  const calculateProgress = () => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    // Se ainda não começou
    if (isAfter(start, today)) return 0;
    // Se já terminou
    if (isAfter(today, end)) return 100;

    const totalDays = differenceInDays(end, start);
    const daysElapsed = differenceInDays(today, start);
    
    return Math.min(100, Math.max(0, (daysElapsed / totalDays) * 100));
  };

  const formatDate = (date?: string | number) => {
    if (!date) return '';
    const parsedDate = typeof date === 'number' ? new Date(date) : parseISO(date);
    return format(parsedDate, 'dd/MM/yyyy', { locale: ptBR });
  };

  const progress = calculateProgress();

  return (
    <div className="space-y-2">
      <div className={`w-full rounded-2xl h-[10px] border border-[#C7D3EB] relative`}>
        <div
          className="absolute top-[-1px] left-[-1px] rounded-2xl bg-[#FF3E5A] h-[10.5px] transition-all duration-300"
          style={{ width: `calc(${progress ? progress : 3}% + 2px)` }}
        ></div>
      </div>

      {/* Datas abaixo da barra, como na Agenda de Apreciação: ao lado dela, em 14px,
          não sobrava largura para a barra nos cartões estreitos e no celular.
          São <span> porque o `p + p` global empurraria a segunda data 8px para baixo. */}
      <div className="flex flex-wrap justify-between gap-x-3 text-sm font-normal">
        <span className="whitespace-nowrap">De {formatDate(startDate)}</span>
        <span className="whitespace-nowrap">Até {formatDate(endDate)}</span>
      </div>
    </div>
  );
}